export default {
  FixedPeriod: 'engineering.isolation-aging.parameters.fixed-period',
  InitialDate: 'engineering.isolation-aging.parameters.initial-date',
  FinalDate: 'engineering.isolation-aging.parameters.final-date',
  InitialTime: 'engineering.isolation-aging.parameters.initial-time',
  FinalTime: 'engineering.isolation-aging.parameters.final-time',
  MovingPeriod: 'engineering.isolation-aging.parameters.moving-period',
  Days: 'engineering.isolation-aging.parameters.days',
  ConsiderHumidity: 'engineering.isolation-aging.parameters.consider-humidity',
  PaperHumiditySource: 'engineering.isolation-aging.parameters.paper-humidity-source',
  PaperHumidity: 'engineering.isolation-aging.parameters.paper-humidity',
  ReferenceHumidity: 'engineering.isolation-aging.parameters.reference-humidity',
  ReferenceHumidityPercentage: 'engineering.isolation-aging.parameters.reference-humidity-percentage',
  HumidityCurveMethod: 'engineering.isolation-aging.parameters.humidity-curve-method',
  OxygenOil: 'engineering.isolation-aging.parameters.oxygen-oil',
  TotalAssetLifeExpectancyInYears: 'engineering.isolation-aging.parameters.total-asset-life-expectancy-in-years',
};
